import React from "react";
import {injectIntl} from "react-intl";
import {PARTS} from "../../../../schemas/accessRightsModel";
import CheckBox from "../../CheckBox";

const assignToList = ["retail", "cost", "discounts"];

const MarkUpModalContent = (props) => {

  const {markUpLogic, setMarkUpLogic, intl, AR} = props;

  const changeMarkUp = (applyFor, property, value) => {
    if (property === "value" && value > 100) {
      value = 100
    }
    const newObj = Object.assign({}, markUpLogic, {
      [applyFor]: Object.assign({}, markUpLogic[applyFor], {
        [property]:value
      })
    });
    // console.log("newObj", newObj);
    setMarkUpLogic(newObj);
  }

  return (
    <div className="ui-popup-body fs-mark ui-list">
      {assignToList.map(assignTo => {
        if(!AR.isSiteAdmin(false)) {
          if(assignTo == assignToList[0] && !AR.v(PARTS.HEADER_BUTTON_MARKUP_RETAIL))
            return null;
          if(assignTo == assignToList[1] && !AR.v(PARTS.HEADER_BUTTON_MARKUP_COST))
            return null;
          if(assignTo == assignToList[2] && !AR.v(PARTS.HEADER_BUTTON_MARKUP_DISCOUNT))
            return null;
        }
        const neededObject = markUpLogic[assignTo] || {value: "", type: ""};
        return (
          <li className={"ui-list-item flex"} key={assignTo}>
            <div className="ui-input-wrapper">
              <label htmlFor={assignTo} className="ui-input__label text-uppercase text-left">
                {assignTo}
              </label>
              <input className="generic-popup-textbox"
                     id={assignTo}
                     placeholder="0%"
                     maxLength={10}
                     value={neededObject.value}
                     onChange={(event) => changeMarkUp(assignTo, "value", event.target.value)}/>
            </div>
            <CheckBox checked={neededObject.type === "mark_up"}
                      innerStyle="none"
                      type={"tiny"}
                      text={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.mark.mark_up"})}
                      onChecked={() => changeMarkUp(assignTo, "type", "mark_up")}/>
            <CheckBox checked={neededObject.type === "mark_down"}
                      innerStyle="none"
                      type={"tiny"}
                      text={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.mark.mark_down"})}
                      onChecked={() => changeMarkUp(assignTo, "type", "mark_down")}/>
          </li>
        )
      })}
    </div>
  )
};

export default injectIntl(
  MarkUpModalContent
)
